import { render, staticRenderFns } from "./MainRegisterVendor.vue?vue&type=template&id=6f749164"
import script from "./MainRegisterVendor.vue?vue&type=script&lang=js"
export * from "./MainRegisterVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports